<template>
  <div class="transactions-list">
    <div class="filter-section-container">
      <div class="filter-fixed">
        <span class="filter-fixed-title">{{ $t('data.filter_section') }}</span>
        <i
          class="el-icon-arrow-down filter-fixed-arrow"
          :class="{'fiter-icon-arrow-route':!showFilterContent}"
          @click="onClickFixedArrow"
        />
      </div>
      <el-collapse-transition>
        <div v-show="showFilterContent">
          <div id="filter-content" class="filter-content">
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('payment_links.create_time') }}</div>
              <el-date-picker
                v-model="search.createTimeList"
                class="filter-item-value"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00','23:59:59']"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
                :picker-options="$commonFn.dateLimit(this, 90)"
              />
            </div>
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('payment_links.complete_time') }}</div>
              <el-date-picker
                v-model="search.completeTimeList"
                class="filter-item-value"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00','23:59:59']"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
                :picker-options="$commonFn.dateLimit(this, 90)"
              />
            </div>
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('payment_links.payment_status') }}</div>
              <el-select v-model="search.status" :placeholder="$t('payment_links.payment_status')" size="small" class="filter-item-value" clearable>
                <el-option v-for="(item,index) in checkoutOrderStatusMap" :key="index" :label="item.label" :value="item.value" />
              </el-select>
            </div>
            <div class="filter-operate">
              <div class="filter-operate-left">
                <el-tooltip placement="top">
                  <div slot="content">
                    <span> {{ $t('payment_links.only_successful_transactions') }}</span>
                  </div>
                  <el-button class="mb-10 download-btn" :loading="downloading" type="info" size="small" icon="el-icon-download" @click="onClickDowmloadBtn">{{ $t('components.download') }}</el-button>
                </el-tooltip>
              </div>
              <div class="filter-operate-right">
                <el-button class="search-btn mb-10" size="small" @click="onClickReset">{{ $t('components.clear') }}</el-button>
                <el-button class="search-btn mb-10" type="primary" size="small" icon="el-icon-search" @click="onClickSearchBtn">{{ $t('components.search') }}</el-button>
              </div>
            </div>
          </div>
        </div>
      </el-collapse-transition>
    </div>
    <div class="tableContainer">
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        style="width: 100%"
      >
        <el-table-column :label="$t('payment_links.checkout_order_id')" align="center">
          <template slot-scope="scope">
            {{ scope.row.checkout_id }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('payment_links.amount')" align="center">
          <template slot-scope="scope">
            {{ scope.row.transaction_amount | toDivideWithDot }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('payment_links.customer_name')" align="center">
          <template slot-scope="scope">
            {{ scope.row.customer_name }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('payment_links.payment_channel')" align="center">
          <template slot-scope="scope">
            {{ scope.row.payment_channel }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('payment_links.payment_status')" min-width="100" align="center">
          <template slot-scope="scope">
            <el-tag class="tag-custom" :type="getCheckoutOrderStatusMap(scope.row.status).type"> {{ getCheckoutOrderStatusMap(scope.row.status).label }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column :label="$t('payment_links.create_time')" min-width="108" align="center">
          <template slot-scope="scope">
            {{ scope.row.create_time }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('payment_links.complete_time')" min-width="108" align="center">
          <template slot-scope="scope">
            {{ scope.row.complete_time }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('components.operation')" align="center">
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">
                <span> {{ $t('components.detail') }}</span> <br>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-detail" @click="onClickDetailBtn(scope.row.checkout_id)" />
            </el-tooltip>
          </template>
        </el-table-column>

      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
    </div>

    <TransactionsListModal ref="transactionsListModal" />
  </div>
</template>

<script>
import { mchDownloadCheckout, mchPageCheckout } from '@/api/payment-link/payment-link'
import { filterEmptyAttr, exportXlsx } from '@/utils/common'
import { checkoutOrderStatusMap } from '@/utils/maps'

export default {
  name: 'Transactions_List',
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    TransactionsListModal: () => import('../Modal/TransactionsListModal.vue')
  },
  data() {
    return {
      sub_merchant_no: this.$route.params.sub_merchant_no,
      createTimeList: null,
      completeTimeList: null,
      status: null,
      tableData: [],
      listLoading: false,
      downloading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      search: {},
      showFilterContent: true
    }
  },
  computed: {
    checkoutOrderStatusMap() {
      return checkoutOrderStatusMap()
    },
    getCheckoutOrderStatusMap() {
      return val => checkoutOrderStatusMap(val)
    }
  },
  created() {
    const { status } = this.$route.params
    this.status = Number(status)
    this.onClickSearchBtn()
  },
  methods: {
    onClickSearchBtn(otherParams = {}) {
      // if (!this.search.qr_stand_no && !this.search.qr_stand_type && !this.search.transaction_id && !this.createTimeList && !this.returnTimeList) {
      //   return this.$message.warning('At least one parameter')
      // }
      const params = this.getParams(otherParams)

      this.listLoading = true
      mchPageCheckout(params).then(res => {
        this.tableData = res.data.list
        this.listQuery.total = res.data.total
        this.listQuery.page = params.page ? params.page : 1
        this.totalCount = res.data.total
        this.totalAmount = res.data.total_amount
        this.totalFee = res.data.total_fee
      }).finally(() => {
        this.listLoading = false
      })
    },
    getParams(otherParams = {}) {
      const { limit } = this.listQuery
      const { status, createTimeList = [], completeTimeList = [] } = this.search
      let params = {
        sub_merchant_no: this.sub_merchant_no,
        create_start_time: createTimeList && createTimeList[0],
        create_end_time: createTimeList && createTimeList[1],
        complete_start_time: completeTimeList && completeTimeList[0],
        complete_end_time: completeTimeList && completeTimeList[1],
        status,
        link_no: this.$route.query.link_no,
        size: limit,
        ...otherParams
      }
      params = filterEmptyAttr(params)
      return params
    },
    onClickReset() {
      this.search = {}
    },
    onClickDetailBtn(checkout_id) {
      this.$refs.transactionsListModal.showModal(checkout_id)
    },
    onClickPaginator() {
      const { page, limit } = this.listQuery
      const params = {
        page,
        size: limit
      }
      this.onClickSearchBtn(params)
    },
    onClickFixedArrow() {
      this.showFilterContent = !this.showFilterContent
    },
    onClickDowmloadBtn() {
      const params = this.getParams()
      if (!params) {
        return
      }
      this.downloading = true
      mchDownloadCheckout(params).then(res => {
        if (res.code === 10000) {
          const { is_async, list } = res.data || {}
          if (is_async) {
            this.$message.success('Downloading')
            this.$store.commit('app/SET_SHOW_DOWNLOAD_LIST', true)
            // download(res.data.url)
          } else {
            this.handleXlsxData(list).then((downloadData) => {
              exportXlsx(downloadData, 'Payment Links')
            })
          }
        }
      }).finally(() => {
        this.isShowBorderRed = {}
        setTimeout(() => {
          this.downloading = false
        }, 3000)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-operate{
  width: 100%;
  padding-top: 16px;
}
.tag-custom{
  width: 80px;
  border-radius: 30px;
  height: 30px;
  line-height: 30px;
  border: none;
  vertical-align: middle;
  &.el-tag--info{
    color: #B45309;
    background-color: #FDE68A;
  }
  &.el-tag--success{
    color: #047857;
    background-color: #A7F3D0;
  }
  &.el-tag--danger{
    color: #71110E;
    background-color: #FCA5A5;
  }
}

</style>
